import { useGlobal } from '@/utils/useGlobal';
import BackToTop from '@elem/compCommon/BackToTop';
import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import ShopifyCartIcon from '@elem/compCommon/ShopifyCartIcon';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import ShopifyShoppingCart from 'elem/compCommon/ShopifyShoppingCart';
import { ShopifyCartItemType } from 'elem/compCommon/ShopifyShoppingCart/const';
import { createPortal } from 'react-dom';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import O from './components/O';
import P from './components/P';
import Q from './components/Q';
import R from './components/R';

export default function IndexDynamic() {
    const { useState, useLang, useEffect, useRouter } = useGlobal();
    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [visible, setVisible] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [updateSolar, setUpdateSolar] = useState(null);
    const { t } = useLang('offgrid');
    const { locale } = useRouter();

    const obj: SideMenuProps = {
        items: [
            { text: t('fix_tab1'), link: '#off-grid-B' },
            { text: t('fix_tab2'), link: '#off-grid-C' },
            { text: t('fix_tab3'), link: '#off-grid-D' },
            { text: t('fix_tab4'), link: '#off-grid-F' },
            { text: t('fix_tab5'), link: '#off-grid-O' },
            { text: t('fix_tab6'), link: '#off-grid-P' },
            { text: t('fix_tab7'), link: '#off-grid-Q' },
            { text: t('fix_tab8'), link: '#off-grid-R' },
        ],
    };

    const handleAddCart = (cards: ShopifyCartItemType[]) => {
        let result = JSON.parse(JSON.stringify(shoppingCarts));
        cards?.map((card: ShopifyCartItemType) => {
            const obj: ShopifyCartItemType = JSON.parse(JSON.stringify(card));
            if (card?.parentVariantId) {
                const target = result.find(
                    (item: ShopifyCartItemType) =>
                        item?.productId === card?.productId && item?.variantId === card?.variantId && item?.parentVariantId === card?.parentVariantId,
                );
                // 附属产品
                obj.quantity = Number(obj?.inventory) > 0 ? obj.quantity : 0;
                result = result.filter((item: ShopifyCartItemType) => !(item?.parentVariantId === card?.parentVariantId));
                if (target) {
                    result = [
                        obj,
                        ...result?.filter((item: any) => !(item?.variantId === target?.variantId && item?.parentVariantId === item?.parentVariantId)),
                    ];
                } else {
                    result = [obj, ...result];
                }
            } else {
                // 主产品
                const target = result.find((item: ShopifyCartItemType) => item?.productId === card?.productId && item?.variantId === card?.variantId);
                if (target) {
                    obj.quantity = target.quantity;
                    result = [
                        obj,
                        ...result?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
                    ];
                } else {
                    obj.quantity = Number(obj?.inventory) > 0 ? 1 : 0;
                    result = [obj, ...result];
                }
            }
        });
        //setShoppingCarts(result);
        EcoDesignEventsBus.emit('eco-cart-add', result);
        setVisible(true);
    };

    const handleCallback = (carts: ShopifyCartItemType[], isClose?: boolean, target?: string) => {
        //setShoppingCarts(carts);
        EcoDesignEventsBus.emit('eco-cart-add', carts);
        if (isClose) {
            setVisible(false);
        }
        if (target) {
            setUpdateSolar(target);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <B />
            <C />
            <D />
            <E callBuy={handleAddCart} updateSolar={updateSolar} />
            <EmailSubscribe locale={locale} className="email-subscribe" pageType={PAGE_TYPE.OffGrid} entry_position={5} />
            <F />
            <O />
            <P />
            <Q />
            <R />
            {visible && isClient && createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}
            {isClient &&
                createPortal(
                    <ShopifyCartIcon
                        quantity={shoppingCarts.reduce((prev: number, curItem: ShopifyCartItemType) => {
                            return prev + Number(curItem.quantity);
                        }, 0)}
                        callback={() => setVisible(true)}
                    />,
                    document.body,
                )}
            {isClient && createPortal(<BackToTop />, document.body)}
            {isClient && createPortal(<SideMenu items={obj.items} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
        </>
    );
}
